// Backend config. Public values (Cognito IDs, API URL are not secrets).
// Regenerated from CDK outputs on deploy; env vars override for local/CI.
export const config = {
  apiEndpoint: (import.meta.env.VITE_API_ENDPOINT || 'https://a287ffevca.execute-api.eu-west-1.amazonaws.com').replace(/\/$/, ''),
  region: import.meta.env.VITE_AWS_REGION || 'eu-west-1',
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'eu-west-1_ZTu3wcRWg',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '3ope6ftekp9i74hr8i8bgf52pd',
  // Cloudflare Turnstile site key — empty → captcha widget is a no-op (dev).
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITEKEY || '',
}
